import { link } from 'fs';
import React from 'react'
import { Link } from 'react-router-dom';

const DetailBadge = ({ title, desc ,isLink=false}: {isLink?:boolean, title: string; desc: string }) => {

  if (!desc) return null
  return (
    <div>
      <h3 className="font-medium text-[#98A2B3] text-[14px]">{title}</h3>
      {
        isLink ? <Link className='underline text-sm' to={desc}>View</Link>:

      <p className="font-medium text-[#667085]  text-[16px]">{desc}</p>
      }
    </div>
  );
};


export default DetailBadge